import PropTypes from 'prop-types';
import React from 'react';
import RatingOptionButton from '../../common/rating-option-button';
import { EMOJI_SCORES } from '../../constants/feedback-constants';
import {
  AngryFace, GrinningFace, NeutralFace, SlightlySmilingFace, WorriedFace,
} from './emoji-faces';

// One SVG face per score (1 = angry … 5 = grinning), so the scale looks the
// same on every OS instead of using the system emoji font.
const FACE_RENDERERS = {
  1: () => <AngryFace />,
  2: () => <WorriedFace />,
  3: () => <NeutralFace />,
  4: () => <SlightlySmilingFace />,
  5: () => <GrinningFace />,
};

const EmojiRating = ({ value, onChange }) => (
  <div className="flex gap-3">
    {EMOJI_SCORES.map((score) => (
      <RatingOptionButton
        key={score}
        score={score}
        renderIcon={FACE_RENDERERS[score]}
        highlighted={value !== null && score <= value}
        className="feedback-icon-option feedback-emoji-option"
        onSelect={onChange}
      />
    ))}
  </div>
);

EmojiRating.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

EmojiRating.defaultProps = {
  value: null,
};

export default EmojiRating;
